import { render } from "./AdminBar.vue?vue&type=template&id=78226ec5&ts=true"
import script from "./AdminBar.vue?vue&type=script&lang=ts"
export * from "./AdminBar.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__